function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32.1439 364C11.9888 369.673 -1.37437 380.689 0.11272 400.42C1.55287 419.528 14.1573 436.548 30.1308 447.271C46.1049 457.995 65.1624 463.207 84.1218 466.655C153.143 479.21 224.218 480.796 294.081 475.775C364.288 470.729 435.707 474.093 506.463 470.126C551.238 467.616 596.012 465.106 640.787 462.596C675.715 460.637 710.774 458.664 745.112 452.01C761.006 448.931 777.3 444.559 789.671 434.171C802.041 423.783 809.354 405.875 802.974 391.078C797.977 379.493 785.698 372.233 773.189 370.181C760.68 368.129 747.881 370.519 735.59 373.609C699.354 382.719 664.76 397.95 628.054 404.958C594.742 411.319 560.506 410.747 526.628 409.051C409.62 403.189 293.743 384.223 177.702 368.189C153.045 364.781 76.2956 351.573 32.1439 364Z",
  fill: "#E5E9F0",
  fillOpacity: 0.3
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M289.812 299.886C289.812 311.484 299.215 320.886 310.812 320.886H478.491C490.089 320.886 499.491 311.484 499.491 299.886V70.001C499.491 58.403 490.089 49.001 478.491 49.001H310.813C299.215 49.001 289.812 58.403 289.812 70.001V299.886Z",
  fill: "#F3F5FB"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M410.677 133.67C418.313 134.754 425.948 135.838 433.584 136.922C440.824 137.95 448.11 138.981 455.417 138.695C450.474 121.218 447.799 106.742 441.345 91.5454C436.301 97.6789 410.491 133.644 410.677 133.67Z",
  fill: "white"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M320.541 166.998C311.169 171.103 303.586 181.862 306.449 194.371C307.976 201.043 312.209 206.606 317.383 209.698C327.295 215.619 342.067 214.371 349.166 203.27C353.988 195.728 354.601 184.365 350.665 176.082C345.164 164.505 331.372 162.254 320.541 166.998Z",
  fill: "white"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M462.088 232.065C459.254 247.334 457.49 262.799 456.807 278.342C440.672 275.343 424.354 273.319 408.004 272.286C410.065 272.409 414.181 230.369 414.874 226.313C414.935 225.956 415.016 225.567 415.331 225.348C415.638 225.135 416.075 225.151 416.472 225.175C420.467 225.426 462.629 228.971 462.088 232.065Z",
  fill: "white"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M697.101 293.631H520.191L544.946 74.9265H721.856L697.101 293.631Z",
  fill: "#F3F5FB"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M171.617 275.018H546.234V257.734H171.617V275.018Z",
  fill: "#EBEEF4"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M196.992 428.577H211.015V273.024H196.992V428.577Z",
  fill: "#EBEEF4"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M504.832 428.577H518.855V273.024H504.832V428.577Z",
  fill: "#EBEEF4"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M399.018 252.417H252.725C251.08 252.417 249.746 253.756 249.746 255.408C249.746 257.06 251.08 258.399 252.725 258.399H399.018C400.663 258.399 401.997 257.06 401.997 255.408C401.997 253.756 400.663 252.417 399.018 252.417Z",
  fill: "#DEE7EE"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M249.828 252.416H342.566L317.362 200.466C316.012 197.682 313.172 195.912 310.059 195.912H225.889C224.281 195.912 223.224 197.58 223.922 199.018L249.828 252.416Z",
  fill: "#DEE7EE"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M277.929 226.751C278.903 228.513 280.379 229.528 281.226 229.018C282.073 228.507 281.97 226.664 280.996 224.902C280.021 223.14 278.545 222.124 277.698 222.634C276.851 223.145 276.955 224.988 277.929 226.751Z",
  fill: "white"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M395.988 111.332C395.322 111.209 394.654 111.092 393.984 110.98",
  stroke: "#D1D8E5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M390.642 110.47C377.346 108.336 363.344 109.51 351.579 115.899C339.31 122.56 330.111 135.596 329.875 149.379",
  stroke: "#D1D8E5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "5.05 5.05"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M329.49 150.709C329.511 151.373 329.547 152.037 329.599 152.703",
  stroke: "#D1D8E5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M344.767 216.52C344.786 217.201 344.882 217.866 345.034 218.514",
  stroke: "#D1D8E5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M346.571 221.173C346.842 221.604 347.126 222.025 347.413 222.437C353.416 231.068 361.334 238.488 370.778 243.04C379.183 247.091 388.834 248.758 397.989 247.167",
  stroke: "#D1D8E5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "5.07 5.07"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M399.993 246.962C400.662 246.843 401.331 246.712 401.996 246.57",
  stroke: "#D1D8E5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "M460.09 151.374C460.551 151.574 460.995 151.797 461.425 152.038",
  stroke: "#D1D8E5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  d: "M464.098 154.032C467.758 157.224 470.287 161.753 472.145 166.27C479.584 184.352 479.165 205.339 471.135 223.167",
  stroke: "#D1D8E5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "4.96 4.96"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  d: "M470.109 225.161C469.892 225.607 469.669 226.05 469.441 226.491",
  stroke: "#D1D8E5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.42,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M94.2576 135.697C95.0803 135.217 95.9638 134.725 96.9186 134.756C97.9591 134.79 98.8634 135.437 99.6916 136.062C109.542 143.499 118.858 151.632 127.545 160.377C116.368 158.662 104.456 162.615 96.5837 170.651C89.5633 161.56 80.0853 158.176 69.4492 155.407C71.3366 146.888 87.6233 139.565 94.2576 135.697Z",
  fill: "#E5E9F0"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.42,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M161.268 185.399C167.317 184.341 172.851 181.829 178.256 178.629C178.786 184.396 173.554 193.212 171.499 198.862C170.705 201.042 169.845 203.29 168.184 204.913C165.891 207.151 162.519 207.796 159.355 208.337C149.9 209.956 139.827 213.003 130.214 211.427C136.493 207.93 143.888 205.606 148.412 199.713C151.559 195.613 153.5 190.744 155.402 185.943C157.416 185.921 159.368 185.732 161.268 185.399Z",
  fill: "#E5E9F0"
});

var SvgOurOptionsOfficeSpace = function SvgOurOptionsOfficeSpace(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 553,
    height: 479,
    viewBox: "0 0 553 479",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgOurOptionsOfficeSpace, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/our-options-office-space.c40f4ca1.svg";
export { ForwardRef as ReactComponent };